export default __webpack_public_path__ + "static/media/906.6169605b.gif";